import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Breadcrumb = ({ className = '', title = '', subtitle = '', titleKey = '', subtitleKey = '' }) => {
  const { t } = useTranslation();

  // Use translation keys if provided, otherwise use the direct text
  const displayTitle = titleKey ? t(titleKey, title) : title;
  const displaySubtitle = subtitleKey ? t(subtitleKey, subtitle) : subtitle;

  return (
    <div className={`breadcumb-wrapper ${className}`} data-bg-src="assets/img/bg/breadcrumb-bg.png" data-overlay="smoke" data-opacity="7">
      <div className="container">
        <div className="breadcumb-content">
          <h1 className="breadcumb-title" data-cue="slideInUp">{displayTitle}</h1>
          <ul className="breadcumb-menu">
            <li data-cue="slideInUp" data-delay="100">
              <Link to="/">{t('sections.breadcrumb.home','Home')}</Link>
            </li>
            <li data-cue="slideInUp" data-delay="100">{displaySubtitle}</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Breadcrumb;